export type ChatflowPermission =
  | 'CHATFLOW_VIEW'
  | 'CHATFLOW_CREATE'
  | 'CHATFLOW_EDIT'
  | 'CHATFLOW_PUBLISH'
  | 'CHATFLOW_ARCHIVE'
  | 'CHATFLOW_MANAGE_DISPLAY_RULES'
  | 'CHATFLOW_MANAGE_SCHEDULE'
  | 'CHATFLOW_MANAGE_ROUTING'
  | 'CHATFLOW_MANAGE_WIDGET'
  | 'CHATFLOW_MANAGE_LOCALIZATION'
  | 'CHATFLOW_MANAGE_TICKET_AUTOMATION'
  | 'CHATFLOW_MANAGE_CSAT'
  | 'CHATFLOW_VIEW_REPORTS'
  | 'CHATFLOW_VIEW_TEAM_REPORTS'
  | 'CHATFLOW_MANAGE_PRIVACY'
  | 'CHATFLOW_DELETE_TRANSCRIPTS'
  | 'CHATFLOW_EXPORT_TRANSCRIPTS'
  | 'CHATFLOW_VIEW_ALL_CONVERSATIONS'
  | 'CHATFLOW_TRANSFER_CONVERSATIONS';

export interface ChatflowUserPermissions {
  userId: number;
  roleName: string;
  permissions: ChatflowPermission[];
}

/** Mapping de permisos por rol como fallback hasta que exista endpoint de permisos */
export const ROLE_PERMISSION_MAP: Record<string, ChatflowPermission[]> = {
  'Super Admin': [
    'CHATFLOW_VIEW', 'CHATFLOW_CREATE', 'CHATFLOW_EDIT', 'CHATFLOW_PUBLISH',
    'CHATFLOW_ARCHIVE', 'CHATFLOW_MANAGE_DISPLAY_RULES', 'CHATFLOW_MANAGE_SCHEDULE',
    'CHATFLOW_MANAGE_ROUTING', 'CHATFLOW_MANAGE_WIDGET', 'CHATFLOW_MANAGE_LOCALIZATION',
    'CHATFLOW_MANAGE_TICKET_AUTOMATION', 'CHATFLOW_MANAGE_CSAT', 'CHATFLOW_VIEW_REPORTS',
    'CHATFLOW_VIEW_TEAM_REPORTS', 'CHATFLOW_MANAGE_PRIVACY', 'CHATFLOW_DELETE_TRANSCRIPTS',
    'CHATFLOW_EXPORT_TRANSCRIPTS', 'CHATFLOW_VIEW_ALL_CONVERSATIONS', 'CHATFLOW_TRANSFER_CONVERSATIONS'
  ],
  'Admin': [
    'CHATFLOW_VIEW', 'CHATFLOW_CREATE', 'CHATFLOW_EDIT', 'CHATFLOW_PUBLISH',
    'CHATFLOW_ARCHIVE', 'CHATFLOW_MANAGE_DISPLAY_RULES', 'CHATFLOW_MANAGE_SCHEDULE',
    'CHATFLOW_MANAGE_ROUTING', 'CHATFLOW_MANAGE_WIDGET', 'CHATFLOW_MANAGE_LOCALIZATION',
    'CHATFLOW_MANAGE_TICKET_AUTOMATION', 'CHATFLOW_MANAGE_CSAT', 'CHATFLOW_VIEW_REPORTS',
    'CHATFLOW_VIEW_TEAM_REPORTS', 'CHATFLOW_MANAGE_PRIVACY', 'CHATFLOW_DELETE_TRANSCRIPTS',
    'CHATFLOW_EXPORT_TRANSCRIPTS', 'CHATFLOW_VIEW_ALL_CONVERSATIONS', 'CHATFLOW_TRANSFER_CONVERSATIONS'
  ],
  'Manager': [
    'CHATFLOW_VIEW', 'CHATFLOW_EDIT', 'CHATFLOW_MANAGE_WIDGET', 'CHATFLOW_MANAGE_SCHEDULE',
    'CHATFLOW_MANAGE_TICKET_AUTOMATION', 'CHATFLOW_MANAGE_CSAT', 'CHATFLOW_VIEW_REPORTS',
    'CHATFLOW_VIEW_TEAM_REPORTS', 'CHATFLOW_EXPORT_TRANSCRIPTS',
    'CHATFLOW_VIEW_ALL_CONVERSATIONS', 'CHATFLOW_TRANSFER_CONVERSATIONS'
  ],
  'Agent': [
    'CHATFLOW_VIEW', 'CHATFLOW_TRANSFER_CONVERSATIONS', 'CHATFLOW_EXPORT_TRANSCRIPTS'
  ],
};
